import { STORAGE_KEYS, storage } from "../../../../utils/storage";

export const getDataFromStorage = async () => {
  try {
    const userData = await storage.load({
      key: STORAGE_KEYS.USER_DETAILS,
    });
    return userData;
  } catch (e) {
    return undefined;
  }
};
